module.exports = __webpack_public_path__ + "static/media/magnifying-glass-solid-white.96539802.png";